module.exports = __webpack_public_path__ + "aec875cc8fbed307ac05d31c72278cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/yhzc.png
// module id = 288
// module chunks = 0